// extracted by mini-css-extract-plugin
export default {"tabBar":"MainLayout_tabBar__qH+9N","sideBar":"MainLayout_sideBar__V8vpr","headerMenu":"MainLayout_headerMenu__qwEGc"};